import React from "react";
import { Option, Radio, Text, Wrapper } from "./style";
import type { RowOption } from "../../../../../../../../pages/Design/types";

interface BodyProps {
  options: RowOption[];
}

const MultipleChoice = ({ options }: BodyProps) => {
  return (
    <Wrapper>
      {options.map((option) => {
        return (
          <Option key={option.index}>
            <Radio />
            <Text>{option.value}</Text>
          </Option>
        );
      })}
    </Wrapper>
  );
};

export default MultipleChoice;
